export function AddTag(organizationID: number, trainingSessionID: number, tagID: number): string {
	return `/v1/organizations/${organizationID}/training-sessions/${trainingSessionID}/tags/${tagID}`;
}

export function BulkUpdateGroupShare(organizationID: number): string {
	return `/v1/organizations/${organizationID}/training-sessions/group-share`;
}

export function BulkUpdateOrganizationShare(organizationID: number): string {
	return `/v1/organizations/${organizationID}/training-sessions/share`;
}

export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/training-sessions`;
}

export function Delete(organizationID: number, trainingSessionID: number): string {
	return `/v1/organizations/${organizationID}/training-sessions/${trainingSessionID}`;
}

export function Duplicate(organizationID: number, trainingSessionID: number): string {
	return `/v1/organizations/${organizationID}/training-sessions/${trainingSessionID}/duplicate`;
}

export function GroupIndex(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/training-sessions`;
}

export function GroupShareIndex(organizationID: number, trainingSessionID: number): string {
	return `/v1/organizations/${organizationID}/training-sessions/${trainingSessionID}/group-share`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/training-sessions`;
}

export function RemoveTag(organizationID: number, trainingSessionID: number, tagID: number): string {
	return `/v1/organizations/${organizationID}/training-sessions/${trainingSessionID}/tags/${tagID}`;
}

export function SetItemUsers(organizationID: number, trainingSessionItemID: number): string {
	return `/v1/organizations/${organizationID}/training-session-items/${trainingSessionItemID}/users`;
}

export function ShareIndex(organizationID: number, trainingSessionID: number): string {
	return `/v1/organizations/${organizationID}/training-sessions/${trainingSessionID}/share`;
}

export function Show(organizationID: number, trainingSessionID: number): string {
	return `/v1/organizations/${organizationID}/training-sessions/${trainingSessionID}`;
}

export function Update(organizationID: number, trainingSessionID: number): string {
	return `/v1/organizations/${organizationID}/training-sessions/${trainingSessionID}`;
}

export function UpdateOrganizationShare(organizationID: number, trainingSessionID: number): string {
	return `/v1/organizations/${organizationID}/training-sessions/${trainingSessionID}/share`;
}

